import React from 'react';
import MaintenanceCard from './MaintenanceCard';

const PageMaintenance: React.FC = () => {
  return <MaintenanceCard />;
};

export default PageMaintenance;
